import React from "react"
import styled from "styled-components"
import { NotPhone, onPhone, onTablet, onDesktop } from "../theme/MediaQueries"
import { TrustBody, TrustTitle } from "../theme/Typography"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${onTablet} {
    min-width: 286px;
    align-items: center;
    text-align: center;
  }

  ${onPhone} {
    justify-content: center;
    align-items: center;
  }
`

const TrustImage = styled.img`
  height: 48px;
  margin: 0;
  ${onDesktop} {
    height: 56px;
    margin-bottom: 10px;
  }
`

const Body = styled.div`
  ${TrustBody};
  font-style: ${({ italic }) => (italic ? "italic" : "normal")};
`

const Title = styled.div`
  ${TrustTitle};
  margin-bottom: 10px;
`

const TrustItem = ({ image, title, body, italic }) => (
  <Container>
    <TrustImage src={image} />
    <NotPhone>
      {title && <Title>{title}</Title>}
      {body && <Body italic={italic}>{body}</Body>}
    </NotPhone>
  </Container>
)

TrustItem.propTypes = {}

TrustItem.defaultProps = {}

export default TrustItem
